import * as React from 'react';
import { useState } from 'react';
import { Button, ColorPicker, Stack } from '@mantine/core';
import { randomId } from '@mantine/hooks';
import { OpenModal } from '../../../../../../react-commons/utils/modals/openModal';
import { modals } from '@mantine/modals';

export function ColorPickerFunction(onConfirm: (color: string) => void) {
    const id = randomId();
    OpenModal.ContentModal({
            title: 'Select Color',
            content: <ColorPickerComponent
                onConfirm={(color) => {
                    onConfirm(color);
                    modals.close(id);
                }}
            />,
            id: id,
        },
    );
}

const ColorPickerComponent= ({ onConfirm }: {
    onConfirm: (color: string) => void;
}) => {

    const [value, onChange] = useState('#0D4372');

    return (
        <Stack
            align="stretch"
            justify="center"
        >
            <ColorPicker
                format="hex"
                value={value}
                onChange={onChange}
                swatches={['#0D4372', '#6B3C00', '#205022', '#831311', '#5B176D']}
            />
            <Button onClick={() => onConfirm(value)}>Select Color</Button>
        </Stack>
    );
};
